import openSeat from '../../../../assets/openSeat.svg';
import { FC } from 'react';
import styles from './JoinSeat.module.css';

interface JoinSeatProps {
  onClickSeat: () => void;
  disabled: boolean;
  seatNumber: number;
}

const JoinSeat: FC<JoinSeatProps> = ({ onClickSeat, disabled, seatNumber }) => {
  return (
    <div className="relative z-[12]">
      <button
        className={styles.joinSeatButton}
        onClick={onClickSeat}
        disabled={disabled}
        id={`join-seat-${seatNumber}`}
      >
        <img src={openSeat} alt="Take this seat m-auto" className="mx-auto h-6 w-6" />
        <span className="mx-auto block text-sm">Join Seat</span>
      </button>
    </div>
  );
};

export default JoinSeat;
